module.exports = __webpack_public_path__ + "img/20190805162132819.01f16feb.png";